import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import _ from 'lodash';
import styled from 'styled-components';
import { capfl } from 'common/utils';
import { sprintf } from 'sprintf-js';

import {
  getPageDataSelector,
  getPageIsLoadingSelector
} from 'common/selectors/page';
import {
  getLayoutCategorySettings
} from 'common/selectors/theme';

import { toggleFilters } from 'common/actions/AppActions';
import { BANNERS_TYPE_CATEGORY } from 'common/constants/SiteConstants';
import { ICON_CHEVRON_DOWN } from 'common/constants/IconConstants';
import { fetchBanners } from 'common/actions/PageActions';

import { withCssUnit } from 'common/components/styleguide/utils';
import {
  BlockSecondary,
  BlockTransparent
} from 'common/components/styleguide/grid/Block';
import Button from 'common/components/styleguide/Button';
import Column from 'common/components/styleguide/grid/Column';
import Container from 'common/components/styleguide/grid/Container';
import Row from 'common/components/styleguide/grid/Row';
import Icon from 'common/components/styleguide/Icon';

import Breadcrumbs from 'common/components/_partials/breadcrumbs/index';

import loadable from '@loadable/component';
const SelectSort = loadable(() => import('common/components/category/breadcrumbsWithSort/SelectSort'),
  {ssr: false}
);
const LayoutSwitcher = loadable(() => import('common/components/category/listing/_default/LayoutSwitcher'),
  {ssr: false}
);

import Filters from 'common/components/category/filters/foodfactory';
import ActiveFilters from 'common/components/category/filters/_default/Active';
import Listing from 'common/components/category/listing/_default';
import Pagination from 'common/components/category/PaginationWithPerPage';
import NotFound from 'common/components/NotFound';
import loader from 'assets/images/loader.svg';

import SS from 'common/pages/_style/index';

const S = {};

S.Wrapper = styled(SS.Wrapper)`
  margin-top: -20px;
`;

S.WrapperOrdering = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-end;
  align-items: center;

  // @media (min-width: ${({ theme }) => withCssUnit(theme.breakpoints.md)}) {
  //   flex-direction: row;
  //   justify-content: end;
  //   align-items: right;
  // }
`;

S.WrapperItem = styled.div`
  display: flex;
`;

S.ListingWrapper = styled.div`
  padding-top: 20px;
`;

S.ButtonWrapper = styled.div`
  @media (min-width: ${({ theme }) => withCssUnit(theme.breakpoints.md)}) {
    display: none;
  }
`;

S.Button = styled(Button)`
  background: ${({ theme }) =>
    _.get(theme, 'filters.showFiltersButton.background')};
  font-size: ${({ theme }) =>
    _.get(theme, 'filters.showFiltersButton.fontSize')};
  color: ${({ theme }) => _.get(theme, 'filters.showFiltersButton.color')};
  font-weight: ${({ theme }) =>
    _.get(theme, 'filters.showFiltersButton.fontWeight')};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

class Category extends Component {
  constructor(props) {
    super(props);
    this.onToggleFiltersMenuClick = this.onToggleFiltersMenuClick.bind(this);
  }
  componentDidMount() {
    const { categoryData, fetchCategoryBanners } = this.props;
    if (categoryData) {
      const { urlName } = categoryData;
      fetchCategoryBanners(urlName);
    }
  }
  onToggleFiltersMenuClick(e) {
    e.preventDefault();
    const { toggleFiltersMenu } = this.props;
    toggleFiltersMenu();
  }
  shouldComponentUpdate(nextProps) {
    const {
      categoryData,
      gotFilters,
      gotProducts,
      gotPagination,
      isLoading,
      banners
    } = this.props;
    if (!_.isEqual(categoryData, nextProps.categoryData)) return true;
    if (!_.isEqual(gotFilters, nextProps.gotFilters)) return true;
    if (!_.isEqual(gotProducts, nextProps.gotProducts)) return true;
    if (!_.isEqual(gotPagination, nextProps.gotPagination)) return true;
    if (!_.isEqual(isLoading, nextProps.isLoading)) return true;
    if (!_.isEqual(banners, nextProps.banners)) return true;
    return false;
  }
  render() {
    const {
      t,
      categoryData,
      gotFilters = false,
      gotProducts = false,
      gotPagination = false,
      isLoading = false,
      banners,
      categorySettings = {}
    } = this.props;

    const searchValue = _.get(categoryData, 'search', null);
    let title = '';
    if (searchValue) {
      title = sprintf(
        '%1$s: %2$s',
        capfl(t('searching phrase')),
        decodeURI(searchValue)
      );
    } else {
      title = _.get(categoryData, 'name', '');
    }
    return (
      <S.Wrapper>
        <BlockSecondary marginConfig={{}} paddingConfig={{top:true, bottom:true}}>
          <Container maxWidth={1800}>
            <Breadcrumbs withSameLevels={false} />
          </Container>
        </BlockSecondary>
        {categoryData && gotFilters ? (
          <S.ButtonWrapper>
            <Container>
              <Column size={{ xs: 12 }}>
                <S.Button onClick={this.onToggleFiltersMenuClick} fullWidth>
                  {capfl(t('show filters'))}
                  <Icon className={ICON_CHEVRON_DOWN} />
                </S.Button>
              </Column>
            </Container>
          </S.ButtonWrapper>
        ) : (
          ''
        )}
        <S.ListingWrapper>
          <Container maxWidth={1800}>
            <Row>
              {categoryData && gotFilters ? (
                <Column size={{ xs: 12, md: 3, lg: 2 }}>
                  <Filters />
                </Column>
              ) : (
                ''
              )}
              {gotProducts ? (
                <Column
                  size={{
                    xs: 12,
                    md: gotFilters ? 9 : 12,
                    lg: gotFilters ? 10 : 12
                  }}
                >

                  <BlockTransparent marginConfig={{bottom:true}}>
                    <Row>
                      <Column size={{ xs: 12, md: 7, lg: 9 }}>
                        <ActiveFilters />
                      </Column>
                      <Column size={{ xs: 12, md: 5, lg: 3 }}>
                        <S.WrapperOrdering>
                          <S.WrapperItem>
                            <SelectSort />
                          </S.WrapperItem>
                          <S.WrapperItem>
                            <LayoutSwitcher />
                          </S.WrapperItem>
                        </S.WrapperOrdering>
                      </Column>
                    </Row>
                  </BlockTransparent>

                  <Listing />
                  {gotPagination ? <Pagination /> : ''}
                </Column>
              ) : (
                <NotFound
                  title="can't find any products"
                  imageAlternativeText="404"
                  columnSize={{
                    xs: 12,
                    md: gotFilters ? 9 : 12,
                    lg: gotFilters ? 10 : 12
                  }}
                />
              )}
            </Row>
          </Container>
        </S.ListingWrapper>
        {isLoading ? (
          <SS.Overlay>
            <img src={loader} alt="loader" />
          </SS.Overlay>
        ) : (
          ''
        )}
      </S.Wrapper>
    );
  }
}

const makeMapStateToProps = () => {
  const getPageData = getPageDataSelector();
  const getPageIsLoading = getPageIsLoadingSelector();
  const categorySettings = getLayoutCategorySettings();
  return (state, props) => {
    const pageData = getPageData(state, props);
    const isLoading = getPageIsLoading(state, props);
    return {
      isLoading,
      categoryData: _.get(pageData, 'data'),
      banners: _.get(pageData, 'banners'),
      gotProducts: !_.isEmpty(_.get(pageData, 'products')),
      gotFilters: !_.isEmpty(_.get(pageData, 'filter')),
      gotPagination: !_.isEmpty(_.get(pageData, 'pagination')),
      categorySettings: categorySettings(state, props)
    };
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchCategoryBanners: categoryId => {
      dispatch(fetchBanners(BANNERS_TYPE_CATEGORY, categoryId));
    },
    toggleFiltersMenu: () => {
      dispatch(toggleFilters());
    }
  };
};

const CategoryConnected = connect(
  makeMapStateToProps,
  mapDispatchToProps
)(Category);

export default withTranslation()(CategoryConnected);
